







































































import { Component, Prop, Watch } from 'vue-property-decorator';
import * as api from '@/api';
import { PaginationMixin } from '@/utils/mixin';
import { UserRole, UserRoleArr } from '@/config/map.conf';
import { State } from 'vuex-class';
import AddRgUser from './add-rg-user.vue';

/**
 * rg成员个人列表
 *
 * @author wb_zahnghongwei
 * @date 07/15/2021
 */
@Component({
    components: {
        AddRgUser
    }
})
export default class UserPersonTable extends PaginationMixin {
    @State(state => state.cti.permission.rg_user)
    permission: boolean;

    @Prop()
    rgId: number;
    @Prop({ default: '' })
    userType: string;

    limit: number = 5;
    userList: CommonTypes.RgUserItem[] = [];
    addUserVisible: Boolean = false;
    userRole: CommonTypes.mapObject = UserRole;
    userRoleArr: any[] = UserRoleArr;
    tableLoading: Boolean = true;
    $mtd: any;

    @Watch('userType', { immediate: true })
    onUserType() {
        // 切换外部tab，表格页数需要重置
        this.currentPage = 1;
        this.getRgUser();
    }

    async getRgUser() {
        this.tableLoading = true;
        try {
            const res = await api.rgApi.getRgUser({
                cn: this.currentPage,
                sn: this.limit,
                rgId: this.rgId,
                roles: this.userType
            });
            const { code, data } = res;
            if (code === 200) {
                this.userList = data.items;
                this.total = data.tn;
                if (this.total > 0 && !data.items.length) {
                    this.currentPage -= 1;
                    if (this.currentPage <= 0) {
                        this.currentPage = 1;
                    }
                    this.getRgUser();
                }
            }
            this.userList = res.data.items;
            this.total = res.data.tn;
        } catch (e) {
            this.userList = [];
            console.log(e);
        }
        this.tableLoading = false;
    }
    handleChange(current: number, size: number) {
        this.limit = size;
        this.currentPage = current;
        this.getRgUser();
    }
    // 删除rg成员
    handleDeleteRg(id: number) {
        const _this = this;
        this.$mtd
            .confirm({
                title: '你是否确认删除该 RG 成员？',
                width: '433px',
                showCancelButton: true,
                type: 'warning',
                okButtonText: '删除',
                okButtonProps: {
                    type: 'danger'
                },
                onOk: async () => {
                    try {
                        await api.rgApi.deleteRgUser(id);
                        this.$mtd.message({
                            message: '删除成功',
                            type: 'success'
                        });
                        await _this.getRgUser();
                    } catch (e) {
                        console.log(e);
                    }
                }
            })
            .catch(e => e);
    }
    handleAddUser() {
        this.addUserVisible = true;
    }
    // 设置成员组织架构信息
    setDept(bg: string, bu: string, org: string) {
        let dept: string = '';
        if (bg) {
            dept += `${bg}/`;
        }
        if (bu) {
            dept += `${bu}/`;
        }
        if (org) {
            dept += `${org}`;
        }
        return dept;
    }
    async changeUserRole(id: number, role: string) {
        try {
            const res = await api.rgApi.updateRgUser(id, role);
            const { code } = res;
            if (code === 200) {
                this.$mtd.message({
                    message: '修改成功',
                    type: 'success'
                });
                this.getRgUser();
            }
        } catch (e) {
            this.getRgUser();
            console.log(e);
        }
    }
}
